import React from 'react'
import PropTypes from 'prop-types'

const BlogVideoEmbed = ({ video }) => {
  if (!video?.youtubeId || !video?.title) {
    return null
  }

  const watchUrl = `https://www.youtube.com/watch?v=${video.youtubeId}`
  const embedUrl = `https://www.youtube-nocookie.com/embed/${video.youtubeId}`

  return (
    <figure className="blog-video-embed">
      <div className="blog-video-embed-frame">
        <iframe
          src={embedUrl}
          title={video.title}
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
      <figcaption className="blog-video-embed-caption">
        {video.caption ? <span>{video.caption}</span> : null}
        <a href={watchUrl} target="_blank" rel="noopener noreferrer">
          Watch on YouTube
        </a>
      </figcaption>
    </figure>
  )
}

BlogVideoEmbed.propTypes = {
  video: PropTypes.shape({
    youtubeId: PropTypes.string,
    title: PropTypes.string,
    caption: PropTypes.string,
  }),
}

export default BlogVideoEmbed
